export default "__VITE_ASSET__7OvYV5nG__"